import {
  InputNumber as AntInputNumber,
  ConfigProvider,
  InputNumberProps,
} from "antd";
import { forwardRef, useEffect, useState } from "react";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const InputNumber = forwardRef<HTMLInputElement, InputNumberProps<number>>(
  function (props, ref) {
    const [value, setValue] = useState(props.value);

    useEffect(() => {
      if ("value" in props) {
        setValue(props.value);
      }
    }, [props.value]);

    function changeValue(v: number | null = 0) {
      const vv = v || 0;
      if ("value" in props) {
        props.onChange?.(vv);
      } else {
        setValue(vv);
      }
    }

    return (
      <ConfigProvider
        theme={{
          components: {
            InputNumber: {
              controlHeight: 44,
              handleWidth: 44,
              borderRadius: 4,
              addonBg: "#F5F6F8",
            },
          },
        }}
      >
        <AntInputNumber
          {...props}
          className="w-[218px]"
          addonBefore={
            <div
              className="w-[25px] cursor-pointer select-none"
              onClick={() => {
                if (!!value && value >= 0) {
                  changeValue((value || 0) - 1);
                }
              }}
            >
              <MinusOutlined
                style={{
                  color: "#A09F9F",
                }}
              />
            </div>
          }
          addonAfter={
            <div
              className="w-[25px] cursor-pointer select-none"
              onClick={() => {
                changeValue((value || 0) + 1);
              }}
            >
              <PlusOutlined
                style={{
                  color: "#A09F9F",
                }}
              />
            </div>
          }
          value={value}
          controls={false}
          onChange={changeValue}
          ref={ref}
        />
      </ConfigProvider>
    );
  }
);

export default InputNumber;
